/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationOfferGroupProtectionMutation($input: SaveSimulationOfferGroupProtection_M_simulation_offer_group_protectionInput!) {
    saveSimulationOfferGroupProtection_M_simulation_offer_group_protection(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
